<div 
    class="icon" 
    [ngClass]="{'-L': size === 'L', '-secondary': background === 'secondary'}" 
    *ngIf="type === typePicture.icon || type === typePicture.img "
>
    <flame-icon [svgIcon]="value" *ngIf="type === typePicture.icon" />
    <img [src]="value" alt="logo" *ngIf="type === typePicture.img">
</div>
